"use client";

import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const faqs = [{
  question: "Does FETC endorse the content of external websites linked on this platform?",
  answer: "No. FETC provides links to third-party websites solely for your convenience and information. The inclusion of any link does not imply an endorsement, authorization, or representation of our affiliation with that third party, nor is it an endorsement of their privacy or information security policies or practices."
}, {
  question: "Who is responsible for the privacy practices of these third-party sites?",
  answer: "FETC does not exercise control over third-party websites. These other sites may place their own cookies or other files on your computer, collect data, or solicit personal information from you. We are not responsible for the privacy practices or the content of such websites and recommend you review their specific policies."
}, {
  question: "What should I do before providing information to an external site?",
  answer: "We strongly encourage all visitors to be aware when they leave the FETC website and to read the privacy statements of each and every website that collects personally identifiable information. Your use of third-party websites is at your own risk and subject to the terms and conditions of use for such sites."
}, {
  question: "How does FETC handle data shared with these external partners?",
  answer: "FETC does not share your private account data with third-party links unless explicitly authorized by you for specific service integrations. However, once you navigate away from our domain, our technical protections no longer apply. We maintain a professional boundary to ensure your corporate data remains secure within our managed environment."
}];
export default function ThirdPartyLinks() {
  return <section data-section-id="260677" id="third-party-links" className="w-full bg-[#0F172A] py-14 md:py-18 lg:py-20 min-h-screen flex items-center scroll-mt-[120px] scroll-snap-start overflow-x-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <h2 className="text-3xl md:text-4xl font-default font-bold text-center text-white mb-12">
          Third-Party Links & External Content
        </h2>
        
        <div className="grid gap-6">
          {faqs.map((faq, i) => <Card key={i} data-index={i} className="bg-[#142033] border-[#13B8C8]/18 hover:border-[#13B8C8]/40 transition-colors duration-300 shadow-md">
              <CardHeader className="pb-3">
                <CardTitle className="text-lg md:text-xl font-default font-semibold text-foreground leading-tight break-words">
                  <span className="text-accent mr-2">Q.</span>
                  {faq.question}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-base leading-relaxed text-white font-sans">
                  {faq.answer}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}